import { useEffect, useState } from "react";
import CampaignReport from "./pages/CampaignReport";
import PhishingManager from "PhishingManager";
import { useStores } from "Hooks/useStore";
import { CAMPAIGN_DATA } from "./pages/CampaignReport/CampaignReport.type";
import './styles/PhishingManager.module.scss';


const Phishing = () => {
    const { reportStore } = useStores();
    const { campaignData } = reportStore;
    const showPhishingDashboard = window.location.pathname.includes("/phishing-manager");

    const updateCampaignData = (data: CAMPAIGN_DATA | null) => {
        reportStore.setCampaignData(data);
    }

    useEffect(() => {
        return () => {
            if(campaignData?.id) updateCampaignData(null);
        }
    }, [])

    return <div className="phishingManager">
        {showPhishingDashboard ? <PhishingManager updateCampaignData={updateCampaignData} /> : <CampaignReport showOverallReport={campaignData == null} campaignId={campaignData?.id || null} tenentId={campaignData?.tenentId || null} />}
    </div>
}

export default Phishing;